var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotalDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666687,
    width: 44,
    height: 44,
    rx: 22,
    fill: "#E4E4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1667 25.6673V27.5007C28.1667 27.7438 28.0701 27.9769 27.8982 28.1488C27.7263 28.3207 27.4931 28.4173 27.25 28.4173H17.1667L22.6667 22.0007L17.1667 15.584H27.25C27.4931 15.584 27.7263 15.6806 27.8982 15.8525C28.0701 16.0244 28.1667 16.2575 28.1667 16.5007V18.334",
    stroke: "#7A7A7A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDevice);
export default __webpack_public_path__ + "static/media/total-device.604d4bf357263567eba810c0da0e4f67.svg";
export { ForwardRef as ReactComponent };